
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cI6uD", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherComponentWrapper", () => $8af4b0fc643359aa$export$4f7b43ba65213bd);

var $gwFzn = parcelRequire("gwFzn");

var $luv00 = parcelRequire("luv00");

var $5Zmpm = parcelRequire("5Zmpm");
const $8af4b0fc643359aa$export$4f7b43ba65213bd = (props)=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": "app-navigation-app-switcher",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Zmpm.AppSwitcherComponent), props));
};

});
parcelRegister("5Zmpm", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherComponent", () => $87f5aa0f5bf06dd6$export$6325b69f8dd8cc5d);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $Asv1P = parcelRequire("Asv1P");

var $lGgRw = parcelRequire("lGgRw");

var $iZfSS = parcelRequire("iZfSS");

var $5izcQ = parcelRequire("5izcQ");

var $f1YjX = parcelRequire("f1YjX");

var $9wGTI = parcelRequire("9wGTI");

var $dPJCf = parcelRequire("dPJCf");

var $dPJCf = parcelRequire("dPJCf");

var $7aRa9 = parcelRequire("7aRa9");

var $jmjWc = parcelRequire("jmjWc");

var $bQm3c = parcelRequire("bQm3c");

var $dEBDF = parcelRequire("dEBDF");

var $52id1 = parcelRequire("52id1");

var $akh1w = parcelRequire("akh1w");
const $87f5aa0f5bf06dd6$var$i18n = (0, $2nPZH.defineMessages)({
    appSwitcherTooltip: {
        id: "app-navigation.app-switcher.tooltip",
        defaultMessage: "Switch to..."
    },
    appSwitcherLabel: {
        id: "app-navigation.app-switcher.label",
        defaultMessage: "Switch to other Atlassian services"
    }
});
const $87f5aa0f5bf06dd6$var$CONFLUENCE_PRODUCT = 'confluence';

const $87f5aa0f5bf06dd6$var$SwitcherContentLoadable = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "o1PWq",
    name: "SwitcherContentLoadable",
    loader: async ()=>(await (parcelRequire("28CXB"))).SwitcherContent
});

const $87f5aa0f5bf06dd6$export$582f757cbaeaf9c0 = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { isLicensed: isLicensed, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { isJswXflowUserQSEligible: isJswXflowUserQSEligible } = (0, $52id1.useQuickstartEligible)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    (0, $gwFzn.useEffect)(()=>{
        (async ()=>{
            const { checkJpdCrossJoinNudgeEligibility: checkJpdCrossJoinNudgeEligibility, showJpdCrossJoinNudge: showJpdCrossJoinNudge, triggerJiraCrossJoinNudge: triggerJiraCrossJoinNudge } = await (parcelRequire("3e94X"));
            const isJpdCrossJoinNudgesEligible = await checkJpdCrossJoinNudgeEligibility({
                cloudId: cloudId,
                userId: userId,
                createAnalyticsEvent: createAnalyticsEvent
            });
            isJpdCrossJoinNudgesEligible ? await showJpdCrossJoinNudge({
                cloudId: cloudId,
                userId: userId,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                push: push
            }) : await triggerJiraCrossJoinNudge({
                cloudId: cloudId,
                userId: userId,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                push: push
            });
        })();
    }, [
        cloudId,
        createAnalyticsEvent,
        flags,
        push,
        userId
    ]);
    const onClick = (0, $Asv1P.useCallbackWithAnalytics)(()=>{
        setIsOpen(!isOpen);
    }, {
        type: 'sendUIEvent',
        data: {
            source: 'globalNavigation',
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'appSwitcher',
            attributes: {
                selectedItemPageContext: routeDataRef.current?.routeName,
                navigationLayer: 'global',
                navVersion: '3',
                navdexPointType: (0, $dEBDF.START_TOUCH)
            }
        }
    });
    const onClose = ()=>{
        setIsOpen(false);
    };
    return !isLicensed ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f1YjX.default), {
        cloudId: cloudId,
        product: $87f5aa0f5bf06dd6$var$CONFLUENCE_PRODUCT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        placement: "bottom-start",
        rootBoundary: "document",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($87f5aa0f5bf06dd6$var$SwitcherContentLoadable, {
                cloudId: cloudId,
                onClose: onClose
            }),
        isOpen: isOpen,
        onClose: onClose,
        shouldRenderToParent: true,
        trigger: (triggerProps)=>{
            const appSwitcherTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $akh1w.AppSwitcherNudgeToolTip), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iZfSS.AppSwitcher), {
                onClick: onClick,
                tooltip: // WARN: not importing the message from @atlassian/switcher
                // because single message from this package pulls more than 100 kB
                // of i18n JS into page loading critical path.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $87f5aa0f5bf06dd6$var$i18n.appSwitcherTooltip),
                isSelected: isOpen,
                label: formatMessage($87f5aa0f5bf06dd6$var$i18n.appSwitcherLabel),
                ...triggerProps
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                "data-testid": "app-navigation-app-switcher"
            }, isJswXflowUserQSEligible && (0, $9wGTI.fg)('cc_onboarding_experience') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
                name: "app-switcher-spotlight"
            }, appSwitcherTrigger) : appSwitcherTrigger);
        }
    }));
};
const $87f5aa0f5bf06dd6$export$6325b69f8dd8cc5d = (0, $7aRa9.withFlags)($87f5aa0f5bf06dd6$export$582f757cbaeaf9c0);

});
parcelRegister("Asv1P", function(module, exports) {

$parcel$export(module.exports, "useCallbackWithAnalytics", () => $040545af9856ecf6$export$53c2b9c37c40e0d8);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $fTXBo = parcelRequire("fTXBo");
const $040545af9856ecf6$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const methodRef = (0, $fTXBo.useTrackedRef)(method);
    const payloadRef = (0, $fTXBo.useTrackedRef)(payload);
    return (0, $gwFzn.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("iZfSS", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $9e0b75e670ff7392$export$9923361bd43fa030);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kNHXO = parcelRequire("kNHXO");

var $9RjLU = parcelRequire("9RjLU");

var $8MTIk = parcelRequire("8MTIk");
const $9e0b75e670ff7392$export$9923361bd43fa030 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9RjLU))), {
            color: "currentColor",
            spacing: "spacious",
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
const $9e0b75e670ff7392$export$28833e0dfbd2ac80 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kNHXO))), {
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps',
            color: "var(--ds-icon, #44546F)"
        }),
        component: component,
        href: href,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
var // exists only to extract props
// eslint-disable-next-line import/no-anonymous-default-export
$9e0b75e670ff7392$export$2e2bcd8739ae039 = (props)=>{};

});
parcelRegister("9RjLU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a6526ba72ad9bbb4f9b91ad0dbd2f69>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72d8668a8c12645f$var$_react = $72d8668a8c12645f$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $72d8668a8c12645f$var$_appSwitcher = $72d8668a8c12645f$var$_interopRequireDefault((parcelRequire("kNHXO")));

var $72d8668a8c12645f$var$_appSwitcher2 = $72d8668a8c12645f$var$_interopRequireDefault((parcelRequire("cCp8H")));
function $72d8668a8c12645f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppSwitcherIcon.
 * This component is AppSwitcherIcon, with `UNSAFE_fallbackIcon` set to "AppSwitcherIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72d8668a8c12645f$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $72d8668a8c12645f$var$_react.default.createElement($72d8668a8c12645f$var$_appSwitcher.default, Object.assign({
        LEGACY_fallbackIcon: $72d8668a8c12645f$var$_appSwitcher2.default
    }, props));
$72d8668a8c12645f$var$AppSwitcherIcon.Name = 'AppSwitcherIconMigration';
var $72d8668a8c12645f$var$_default = module.exports.default = $72d8668a8c12645f$var$AppSwitcherIcon;

});


parcelRegister("f1YjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc8696e3d2c183fd$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eEhUN = parcelRequire("eEhUN");

var $cUwlE = parcelRequire("cUwlE");

var $gyt00 = parcelRequire("gyt00");

var $a3xa0 = parcelRequire("a3xa0");

var $03bmy = parcelRequire("03bmy");
const $fc8696e3d2c183fd$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $fc8696e3d2c183fd$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $fc8696e3d2c183fd$var$TRIGGER_CONTEXT = {
    componentName: (0, $a3xa0.TRIGGER_COMPONENT),
    ...(0, $03bmy.default)
};
class $fc8696e3d2c183fd$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick,
            children: children
        });
    }
    constructor(...args){
        super(...args);
        this.lastEnteredAt = void 0;
        this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $a3xa0.OPERATIONAL_EVENT_TYPE),
                actionSubject: (0, $a3xa0.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
        };
        this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($eEhUN)))(()=>{
            (0, $cUwlE.prefetch)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $fc8696e3d2c183fd$var$THROTTLE_EXPIRES, $fc8696e3d2c183fd$var$THROTTLE_OPTIONS);
        this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $gyt00.performanceNow)();
        };
        this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $gyt00.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
const $fc8696e3d2c183fd$var$PrefetchTriggerWithEvents = (0, $a3xa0.withAnalyticsEvents)()($fc8696e3d2c183fd$var$PrefetchTrigger);
var $fc8696e3d2c183fd$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NavigationAnalyticsContext), {
        data: $fc8696e3d2c183fd$var$TRIGGER_CONTEXT,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($fc8696e3d2c183fd$var$PrefetchTriggerWithEvents, {
            ...props
        })
    });

});
parcelRegister("cUwlE", function(module, exports) {

$parcel$export(module.exports, "prefetch", () => $4d0cc6fe2704cf10$export$f003ab04b0b3c00e);

var $lICpR = parcelRequire("lICpR");

var $cA3Tq = parcelRequire("cA3Tq");

var $l2qS4 = parcelRequire("l2qS4");

var $cDgbr = parcelRequire("cDgbr");
const $4d0cc6fe2704cf10$export$f003ab04b0b3c00e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $cDgbr.default)(product);
    (0, $cA3Tq.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $l2qS4.prefetchJoinableSites)(props.joinableSitesDataProvider);
    if (cloudId) (0, $lICpR.prefetchAll)({
        cloudId: cloudId
    });
};

});
parcelRegister("lICpR", function(module, exports) {

$parcel$export(module.exports, "UserPermissionProvider", () => $377f98047994ea77$export$ea5ef74fdb7fc4f8);
$parcel$export(module.exports, "prefetchAll", () => $377f98047994ea77$export$aba5d6cf034db22e);

var $kBWmB = parcelRequire("kBWmB");

var $irYQs = parcelRequire("irYQs");

var $dcO0p = parcelRequire("dcO0p");

var $bgtNw = parcelRequire("bgtNw");

var $adCrz = parcelRequire("adCrz");

var $grirN = parcelRequire("grirN");
const $377f98047994ea77$var$fetchPermission = (0, $bgtNw.withCached)(({ cloudId: cloudId, permissionId: permissionId })=>(0, $kBWmB.postJson)(`/gateway/api/permissions/permitted`, {
        permissionId: permissionId,
        resourceId: `ari:cloud:platform::site/${cloudId}`
    }).then((permission)=>permission.permitted));
const $377f98047994ea77$export$ea5ef74fdb7fc4f8 = (0, $adCrz.default)((0, $irYQs.default)('permission', (0, $grirN.ExperienceMark).API_PERMISSIONS, $377f98047994ea77$var$fetchPermission, $377f98047994ea77$var$fetchPermission.cached), false);
const $377f98047994ea77$export$aba5d6cf034db22e = ({ cloudId: cloudId })=>{
    $377f98047994ea77$var$fetchPermission({
        cloudId: cloudId,
        permissionId: (0, $dcO0p.Permissions).MANAGE
    });
};
const $377f98047994ea77$export$ffe8c06b7e356699 = ()=>{
    $377f98047994ea77$var$fetchPermission.reset();
};

});
parcelRegister("adCrz", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd7f18c1dd90667$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $irYQs = parcelRequire("irYQs");
/**
 * Inject the ability to handle cases when cloudID is missing into the provided component.
 *
 * When cloud ID is available, this HOC will wrap {children} with the given provided component.
 * Otherwise, {children} is executed with the provided fallback result.
 *
 * @param ProviderComponent component to wrap
 * @param fallbackProviderResult result used to execute children if cloud id is missing
 *
 * @type P component props
 * @type U provider result type
 */ function $abd7f18c1dd90667$var$withHandleOptionalCloudId(ProviderComponent, fallbackProviderResult) {
    return function(props) {
        const { cloudId: cloudId, children: children } = props;
        if (cloudId) return /*#__PURE__*/ (0, $7UHDa.jsx)(ProviderComponent, {
            ...props,
            children: children
        });
        else {
            const resultComplete = {
                status: (0, $irYQs.Status).COMPLETE,
                data: fallbackProviderResult
            };
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                children: children(resultComplete)
            });
        }
    };
}
var $abd7f18c1dd90667$export$2e2bcd8739ae039 = $abd7f18c1dd90667$var$withHandleOptionalCloudId;

});


parcelRegister("cA3Tq", function(module, exports) {

$parcel$export(module.exports, "AvailableProductsProvider", () => $d506fce92bbefc59$export$4c169257ef988618);
$parcel$export(module.exports, "prefetchAvailableProducts", () => $d506fce92bbefc59$export$1c5684a3ba697d80);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $9yNEc = parcelRequire("9yNEc");
const { fetchMethod: $d506fce92bbefc59$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $d506fce92bbefc59$var$DefaultBffDataProviderComponent } = (0, $9yNEc.createAppSwitcherBffAvailableProductsProvider)();
const $d506fce92bbefc59$export$4c169257ef988618 = ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)($d506fce92bbefc59$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product,
        children: children
    });
const $d506fce92bbefc59$export$1c5684a3ba697d80 = $d506fce92bbefc59$var$fetchAppSwitcherBffAvailableProducts;
const $d506fce92bbefc59$export$cd9fc41c59711bdd = ()=>$d506fce92bbefc59$var$fetchAppSwitcherBffAvailableProducts.reset();

});
parcelRegister("9yNEc", function(module, exports) {

$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", () => $02cabd97f79fd287$export$7fd9c7ae7afb494c);

var $cj14x = parcelRequire("cj14x");

var $kBWmB = parcelRequire("kBWmB");

var $grirN = parcelRequire("grirN");

var $alOHm = parcelRequire("alOHm");
const $02cabd97f79fd287$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
// TODO: remove this once Asset app becomes standalone app
const $02cabd97f79fd287$var$transformAppSwitcherBffResponse = (response)=>{
    if (response.switcherTeam25ExperimentCohort === 'test' && response.assetsAsAnAppEnabled) response.sites.forEach((site)=>{
        if (site.availableProducts.some((product)=>product.productType === 'JIRA_SERVICE_DESK' && product.isJsmPremium)) site.availableProducts.push({
            productType: (0, $alOHm.ASSETS_APP_KEY)
        });
    });
    return response;
};
const $02cabd97f79fd287$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    const response = await (0, $kBWmB.fetchJsonWithNetworkRetries)(`${$02cabd97f79fd287$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
    return $02cabd97f79fd287$var$transformAppSwitcherBffResponse(response);
};
const $02cabd97f79fd287$export$7fd9c7ae7afb494c = ()=>{
    return (0, $cj14x.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $grirN.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $02cabd97f79fd287$export$1096efb00c5f8afc);
};

});
parcelRegister("alOHm", function(module, exports) {

$parcel$export(module.exports, "COLLAPSED_ORG_SELECTOR_WIDTH", () => $f990887179ccebd8$export$2f90b4ad2fe04542);
$parcel$export(module.exports, "DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH", () => $f990887179ccebd8$export$4103378b1e498da3);
$parcel$export(module.exports, "MIN_ORG_SELECTOR_EXPAND_WIDTH", () => $f990887179ccebd8$export$85408825f773203f);
$parcel$export(module.exports, "MAX_ORG_SELECTOR_EXPANDED_WIDTH", () => $f990887179ccebd8$export$d1ad8b9b8feac8dc);
$parcel$export(module.exports, "ORG_SELECTOR_WIDTH_LS_KEY", () => $f990887179ccebd8$export$22193936843a6dda);
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $f990887179ccebd8$export$45e63649edff1e2a);
const $f990887179ccebd8$export$2f90b4ad2fe04542 = 56;
const $f990887179ccebd8$export$4103378b1e498da3 = 200;
const $f990887179ccebd8$export$85408825f773203f = $f990887179ccebd8$export$2f90b4ad2fe04542 + ($f990887179ccebd8$export$4103378b1e498da3 - $f990887179ccebd8$export$2f90b4ad2fe04542) / 2;
const $f990887179ccebd8$export$d1ad8b9b8feac8dc = 400;
const $f990887179ccebd8$export$22193936843a6dda = 'AS_ORG_SELECTOR_WIDTH';
const $f990887179ccebd8$export$45e63649edff1e2a = 'ASSETS';

});



parcelRegister("l2qS4", function(module, exports) {

$parcel$export(module.exports, "JoinableSitesProvider", () => $19041cad7a2e4757$export$70da68d3b04f82d0);
$parcel$export(module.exports, "prefetchJoinableSites", () => $19041cad7a2e4757$export$2aed3ef1595b4d9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $emHKt = parcelRequire("emHKt");
const { fetchMethod: $19041cad7a2e4757$var$fetchJoinableSites, ProviderComponent: $19041cad7a2e4757$var$DefaultDataProviderComponent } = (0, $emHKt.createJoinableSitesProvider)();
const $19041cad7a2e4757$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $19041cad7a2e4757$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(DataProviderComponent, {
        cloudId: cloudId,
        children: children
    });
};
const $19041cad7a2e4757$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $19041cad7a2e4757$var$fetchJoinableSites({});
};
const $19041cad7a2e4757$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $19041cad7a2e4757$var$fetchJoinableSites.reset();
};

});

parcelRegister("cDgbr", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c26cbd87218cf2$export$2e2bcd8739ae039);

var $dcO0p = parcelRequire("dcO0p");

var $2uNd6 = parcelRequire("2uNd6");
var $58c26cbd87218cf2$export$2e2bcd8739ae039 = (product)=>{
    (0, $2uNd6.loadAtlassianSwitcher)();
    if (product === (0, $dcO0p.Product).JIRA) return (0, $2uNd6.loadJiraSwitcher)();
    if (product === (0, $dcO0p.Product).CONFLUENCE) return (0, $2uNd6.loadConfluenceSwitcher)();
    return (0, $2uNd6.loadGenericSwitcher)();
};

});


parcelRegister("gyt00", function(module, exports) {

$parcel$export(module.exports, "performanceNow", () => $54b2b65df874895b$export$fb4230f160368c88);
const $54b2b65df874895b$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;

});


parcelRegister("52id1", function(module, exports) {

$parcel$export(module.exports, "useQuickstartEligible", () => $c90a71d49e407199$export$6d1ffb649c1cfb52);

var $gwFzn = parcelRequire("gwFzn");

var $1ytiN = parcelRequire("1ytiN");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $1amdO = parcelRequire("1amdO");

var $hl0fg = parcelRequire("hl0fg");

var $ivb8S = parcelRequire("ivb8S");

var $dBcar = parcelRequire("dBcar");
var $3hLsK = parcelRequire("3hLsK");

var $dPJCf = parcelRequire("dPJCf");

var $9wGTI = parcelRequire("9wGTI");

var $aWwYt = parcelRequire("aWwYt");

var $6mKj3 = parcelRequire("6mKj3");

var $jNJeR = parcelRequire("jNJeR");

var $lRAO1 = parcelRequire("lRAO1");
const $c90a71d49e407199$export$6d1ffb649c1cfb52 = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { isMigratedUser: isMigratedUser, isMigratedUserReady: isMigratedUserReady } = (0, $1amdO.useMigratedUser)({
        skip: !(0, $9wGTI.fg)('cc_onboarding_experience')
    });
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { data: data } = (0, $ivb8S.useGetOnboardingState)([
        (0, $3hLsK.ORIGIN_ATTRIBUTES),
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
    ]);
    const state = (0, $ivb8S.deserializeState)(data);
    const checkAllowedRoutes = {
        selector: (name)=>(0, $lRAO1.isNameAllowed)(name)
    };
    const isAllowlistPath = (0, $dPJCf.useRouteName)(checkAllowedRoutes);
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const isWidthThresholdMet = windowWidth >= (0, $jNJeR.QS_WINDOW_WIDTH_THRESHOLD);
    const isAnonymousUser = !userId || !isLicensed;
    const isFoundingAdmin = state?.isFoundingAdmin;
    const isTarget = isAllowlistPath && !isAnonymousUser && isWidthThresholdMet;
    // -------- JSW XFlow Quickstart Targeting
    let isJSWXFlowUser;
    const attributes = state?.attributes ?? '{}';
    try {
        isJSWXFlowUser = JSON.parse(attributes)?.originProduct === 'jira';
    } catch (e) {
        isJSWXFlowUser = false;
    }
    const isNthUserQSV2Eligible = isTarget && !isFoundingAdmin && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isAdminQuickStartV2Eligible = isTarget && isFoundingAdmin && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isMigrationsQuickstartEligible = isTarget && !isSiteAdmin && isMigratedUserReady && isMigratedUser && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isJswXflowUserQSEligible = isJSWXFlowUser && isTarget && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isObjectSidebarCurrentlyShowing = isObjectSidebarShown && (0, $9wGTI.fg)('confluence_frontend_object_sidebar');
    const isQuickstartEligible = ()=>{
        return isTarget && // Allow list paths
        !isFoundingAdmin && // Home Takeover experiment is to replace Quickstart
        !(0, $6mKj3.expValEqualsNoExposure)('cc_onboarding_nth_user_home_takeover', 'cohort', 'experiment') && // core QS experiment FFs
        (isJswXflowUserQSEligible || isAdminQuickStartV2Eligible || isMigrationsQuickstartEligible || isNthUserQSV2Eligible) && !isObjectSidebarCurrentlyShowing && (0, $9wGTI.fg)('cc_onboarding_experience') // Master FF
        ;
    };
    return {
        isTarget: isTarget,
        isSiteAdmin: isSiteAdmin,
        isOnboardingEligible: (0, $9wGTI.fg)('cc_onboarding_experience'),
        isQuickstartEligible: isQuickstartEligible,
        isNthUserQSV2Eligible: isNthUserQSV2Eligible,
        isAdminQuickStartV2Eligible: isAdminQuickStartV2Eligible,
        isMigrationsQuickstartEligible: isMigrationsQuickstartEligible,
        isJswXflowUserQSEligible: isJswXflowUserQSEligible
    };
};

});
parcelRegister("aWwYt", function(module, exports) {

$parcel$export(module.exports, "MIN_PANEL_WIDTH", () => $5371993c50b87836$export$9e0a6941e0e87c97);
$parcel$export(module.exports, "useObjectSidebarActions", () => $5371993c50b87836$export$332594c77a860a26);
$parcel$export(module.exports, "useObjectSidebarState", () => $5371993c50b87836$export$41c5dcc793387db5);
$parcel$export(module.exports, "useIsObjectSidebarShown", () => $5371993c50b87836$export$a572d51222d5ea45);
$parcel$export(module.exports, "usePanel", () => $5371993c50b87836$export$9168a42f32e3d071);
$parcel$export(module.exports, "useBehavior", () => $5371993c50b87836$export$8b43142d6fd506da);
$parcel$export(module.exports, "useIsPanelScrolled", () => $5371993c50b87836$export$ec8631e69ae8c803);
$parcel$export(module.exports, "usePanelWidth", () => $5371993c50b87836$export$82b270f291af5a5);
$parcel$export(module.exports, "useUpdatedHeaderComponentElements", () => $5371993c50b87836$export$bc4f8f2fe52e3d40);
$parcel$export(module.exports, "useSidebarControlState", () => $5371993c50b87836$export$d4d7180dad517777);
$parcel$export(module.exports, "useSidebarControlExpandCollapsedState", () => $5371993c50b87836$export$b00fb66a9723fc58);

var $gwFzn = parcelRequire("gwFzn");

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $8gtQ7 = parcelRequire("8gtQ7");

var $9wGTI = parcelRequire("9wGTI");
const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed'
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: ()=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $4ZoIm.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $iFWZA.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $8gtQ7.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $gwFzn.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $gwFzn.useMemo)(()=>(0, $9wGTI.fg)('confluence_preview_panels') ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $gwFzn.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $gwFzn.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});

});
parcelRegister("8gtQ7", function(module, exports) {

$parcel$export(module.exports, "usePreviewPanelsActions", () => $1e5215e1f439a288$export$5f5debba1692bf40);

var $gwFzn = parcelRequire("gwFzn");

var $2QMNQ = parcelRequire("2QMNQ");
const $1e5215e1f439a288$export$5f5debba1692bf40 = ()=>{
    const context = (0, $2QMNQ.useGetPreviewPanelsContext)();
    const dispatch = context?.dispatch;
    const setPanelWidth = (0, $gwFzn.useCallback)((width)=>{
        dispatch?.({
            type: 'SET_PANEL_WIDTH',
            width: width
        });
    }, [
        dispatch
    ]);
    const close = (0, $gwFzn.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
    }, [
        dispatch
    ]);
    const open = (0, $gwFzn.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
    }, [
        dispatch
    ]);
    return {
        setPanelWidth: setPanelWidth,
        close: close,
        open: open
    };
};

});
parcelRegister("2QMNQ", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelsProvider", () => $0fe21c36979e0689$export$65ae37e9c61321f9);
$parcel$export(module.exports, "useGetPreviewPanelsContext", () => $0fe21c36979e0689$export$3c2e5d25d7ff14aa);
$parcel$export(module.exports, "useIsPreviewPanelOpen", () => $0fe21c36979e0689$export$c68e55e6e77f3d5d);
$parcel$export(module.exports, "useGetCurrentPreviewPanel", () => $0fe21c36979e0689$export$d3e9d6e893b037d8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iJRU1 = parcelRequire("iJRU1");
const $0fe21c36979e0689$export$f473d225913e225d = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $0fe21c36979e0689$export$35041b83145053c1 = (state, action)=>{
    switch(action.type){
        case 'SET_PANEL_WIDTH':
            return {
                ...state,
                width: action.width
            };
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.closePanelSlot();
            return 0, $iJRU1.initialState;
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel.id === params.panel.id) return state;
            // Close the active panel.
            state.onClose();
            state.closePanelSlot();
            // Open the new panel.
            state.openPanelSlot();
            params.onOpen?.();
            return {
                ...state,
                panel: params.panel,
                width: params.width || (0, $iJRU1.initialState).width,
                onOpen: params.onOpen || (0, $iJRU1.initialState).onOpen,
                onClose: params.onClose || (0, $iJRU1.initialState).onClose
            };
        default:
            return state;
    }
};
const $0fe21c36979e0689$export$65ae37e9c61321f9 = ({ productHandleOpen: productHandleOpen, productHandleClose: productHandleClose, children: children })=>{
    (0, $iJRU1.initialState).closePanelSlot = productHandleClose;
    (0, $iJRU1.initialState).openPanelSlot = productHandleOpen;
    const [state, dispatch] = (0, $gwFzn.useReducer)($0fe21c36979e0689$export$35041b83145053c1, (0, $iJRU1.initialState));
    return /*#__PURE__*/ (0, $7UHDa.jsx)($0fe21c36979e0689$export$f473d225913e225d.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
const $0fe21c36979e0689$export$3c2e5d25d7ff14aa = ()=>{
    const context = (0, $gwFzn.useContext)($0fe21c36979e0689$export$f473d225913e225d);
    return context;
};
const $0fe21c36979e0689$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = $0fe21c36979e0689$export$3c2e5d25d7ff14aa();
    return panelId ? context?.state.panel.id === panelId : !!context?.state.panel.id;
};
const $0fe21c36979e0689$export$d3e9d6e893b037d8 = ()=>{
    const context = $0fe21c36979e0689$export$3c2e5d25d7ff14aa();
    return context?.state.panel ?? (0, $iJRU1.initialState).panel;
};

});
parcelRegister("iJRU1", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $85f43b535c1c3f9c$export$d4c72bab9d6cc13a);
const $85f43b535c1c3f9c$export$d4c72bab9d6cc13a = {
    // Configured by the product to allow for nuances in how the
    // product handles opening and closing of the preview panel.
    closePanelSlot: ()=>{},
    openPanelSlot: ()=>{},
    // Configured when opening a panel.
    panel: {
        id: '',
        content: undefined
    },
    width: 400,
    onOpen: ()=>{},
    onClose: ()=>{}
};

});




parcelRegister("jNJeR", function(module, exports) {

$parcel$export(module.exports, "QS_WINDOW_WIDTH_THRESHOLD", () => $0ba04a616e2bedd7$export$a1dbb294430bee02);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART", () => $0ba04a616e2bedd7$export$a653ff2042908ec3);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART_DRAWER", () => $0ba04a616e2bedd7$export$bfca18197eb98eaa);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART_BUTTON", () => $0ba04a616e2bedd7$export$8e7e5010e27a79df);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART_BUTTON_DRAWER", () => $0ba04a616e2bedd7$export$576fbf166bcae0b0);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART_CTA", () => $0ba04a616e2bedd7$export$549db28183a986ea);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART_CAROUSEL_ACTION", () => $0ba04a616e2bedd7$export$68ef35ce157f7396);
$parcel$export(module.exports, "WELCOME_TO_CONFLUENCE_VIDEOS", () => $0ba04a616e2bedd7$export$c7ee3293fdd6b532);
const $0ba04a616e2bedd7$export$a1dbb294430bee02 = 1130;
const $0ba04a616e2bedd7$export$a653ff2042908ec3 = 'confluenceOnboardingQuickstart';
const $0ba04a616e2bedd7$export$bfca18197eb98eaa = 'confluenceOnboardingQuickstartDrawer';
const $0ba04a616e2bedd7$export$8e7e5010e27a79df = 'confluenceOnboardingQuickstartButton';
const $0ba04a616e2bedd7$export$576fbf166bcae0b0 = 'confluenceOnboardingQuickstartButtonDrawer';
const $0ba04a616e2bedd7$export$549db28183a986ea = 'confluenceOnboardingQuickstartCta';
const $0ba04a616e2bedd7$export$68ef35ce157f7396 = 'confluenceOnboardingQuickstartCarouselAction';
const $0ba04a616e2bedd7$export$c7ee3293fdd6b532 = {
    en: 'https://player.vimeo.com/progressive_redirect/playback/676035490/rendition/1080p?loc=external&signature=1ce9207d5a6a8957d85834336f59c42c45b099c8320d3c60cdbfe2f526136ec2',
    jp: 'https://player.vimeo.com/progressive_redirect/playback/738398214/rendition/1080p/file.mp4?loc=external&signature=b1d49a7d7a517d7d245e0d4018b4f4dba97d97c481ced019807dc97fa45631db',
    de: 'https://player.vimeo.com/progressive_redirect/playback/738398180/rendition/1080p/file.mp4?loc=external&signature=29b5a66a0b5a5bc2ef65c6d11048328650ae4c963b29877ac9ab5abac47ef4a4',
    cn: 'https://player.vimeo.com/progressive_redirect/playback/738398158/rendition/1080p/file.mp4?loc=external&signature=3f0f01307ffd26e49240387deb9b703d45cf59359b862dd8d1b68542c5d35166',
    br: 'https://player.vimeo.com/progressive_redirect/playback/738398131/rendition/1080p/file.mp4?loc=external&signature=36299800fdbeefd42b2da49a887e804dbb9c2df500acaab07627f8d01521770f',
    ru: 'https://player.vimeo.com/progressive_redirect/playback/738398112/rendition/1080p/file.mp4?loc=external&signature=26c0364851f5cb0d38d4396e5067473d825e8e633fd0cc204982fd3773f235b2',
    es: 'https://player.vimeo.com/progressive_redirect/playback/738398078/rendition/1080p/file.mp4?loc=external&signature=596aa393f72a91d1485f7b36edf5a9e03e25a1350a923a870181c7cd1e92c21c',
    nl: 'https://player.vimeo.com/progressive_redirect/playback/738398054/rendition/1080p/file.mp4?loc=external&signature=3927a84841c8b9bc1812797a72885a30c45c1749f661bbd15c01f09b067b5915',
    kr: 'https://player.vimeo.com/progressive_redirect/playback/738398022/rendition/1080p/file.mp4?loc=external&signature=ab4e580c57f4f9ca990f1cd917a55a43ad0ed3f3c87cdc3e5592634eb5a6b213',
    pl: 'https://player.vimeo.com/progressive_redirect/playback/738397991/rendition/1080p/file.mp4?loc=external&signature=869e4a87dc2f8d5bd49843d6066c8370dd3f1ca0a2a41e7d9334c9b63bab3d07',
    it: 'https://player.vimeo.com/progressive_redirect/playback/738397952/rendition/1080p/file.mp4?loc=external&signature=1b7a167fff2b5c656f349ed89aac9c88a9224329d7c68835c76e519a7a5b713b',
    fr: 'https://player.vimeo.com/progressive_redirect/playback/738397906/rendition/1080p/file.mp4?loc=external&signature=41b38194e902626c4a55d6ca7ec5ab4e267b395be78bcd15f5f1d0e86b083081'
};

});

parcelRegister("lRAO1", function(module, exports) {

$parcel$export(module.exports, "isNameAllowed", () => $fdef0bf5106d057e$export$4d77218734541822);
/**
 * Matches patterns that are either allowlisted or blocklisted, and returns whether or not it should be allowed
 * to show the quickstart feature
 */ const $fdef0bf5106d057e$export$4d77218734541822 = (name)=>{
    const allowlistPattern = [
        /VIEW_BLOG_DATE_LEGACY/
    ];
    const blocklistPatterns = [
        /EMBED_VIEW/,
        /WHITEBOARD_HOME/,
        /WHITEBOARD_BOARD/,
        /LEGACY/,
        /ADMIN/,
        // this is the legacy calendar - different from "MY_CALENDAR" name
        /^CALENDAR$/
    ];
    if (!name) return false;
    const isAllowlistPath = blocklistPatterns.every((pattern)=>!pattern.test(name)) || allowlistPattern.some((pattern)=>pattern.test(name));
    return isAllowlistPath;
};

});


parcelRegister("akh1w", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherNudgeToolTip", () => $56fef2b484b7e7ea$export$c9637de5a973a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $axAnW = parcelRequire("axAnW");

var $gR84W = parcelRequire("gR84W");

var $1lhEF = parcelRequire("1lhEF");

var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $67Foi = parcelRequire("67Foi");

var $bQm3c = parcelRequire("bQm3c");

var $lwNi3 = parcelRequire("lwNi3");

var $9oxdN = parcelRequire("9oxdN");

var $dIouf = parcelRequire("dIouf");

var $fqxbx = parcelRequire("fqxbx");
var $hUCYs = parcelRequire("hUCYs");
const $56fef2b484b7e7ea$var$i18n = (0, $2nPZH.defineMessages)({
    heading: {
        defaultMessage: "New product added",
        id: "app-navigation.app-switcher-nudge-tooltip.heading"
    },
    jsmContent: {
        defaultMessage: "Someone in your team has just started using Jira Service Management. It\u2019s been added to your site for free.",
        id: "app-navigation.app-switcher-nudge-tooltip.jsm-content"
    },
    jpdContent: {
        defaultMessage: "Someone in your team has just started using Jira Product Discovery. It\u2019s been added to your site for free.",
        id: "app-navigation.app-switcher-nudge-tooltip.jpd-content"
    },
    jsmPrimaryButtonText: {
        defaultMessage: "Take a tour",
        id: "app-navigation.app-switcher-nudge-tooltip.jsm-primary-button-text"
    },
    jpdPrimaryButtonText: {
        defaultMessage: "Show details",
        id: "app-navigation.app-switcher-nudge-tooltip.jpd-primary-button-text"
    },
    secondaryAction: {
        defaultMessage: "Dismiss",
        id: "app-navigation.app-switcher-nudge-tooltip.secondary-action"
    }
});
const $56fef2b484b7e7ea$export$83c8d7110915321e = 'endUserActivateSpotlightScreen';
const $56fef2b484b7e7ea$var$StyledNudge = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...restProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56fef2b484b7e7ea$var$NudgeWrapper, {
        ...restProps,
        ref: ref,
        "data-testid": nudgeTestId
    }, children));
const $56fef2b484b7e7ea$export$5871aa9763d9526b = [
    {
        messageId: 'confluence-end-user-activated-jsm_v2',
        heading: $56fef2b484b7e7ea$var$i18n.heading,
        content: $56fef2b484b7e7ea$var$i18n.jsmContent,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($hUCYs))),
        primaryActionText: $56fef2b484b7e7ea$var$i18n.jsmPrimaryButtonText,
        primaryOnClickAction: ()=>window.open('/secure/WelcomeToSD.jspa?decorator=jsd-onboarding', '_blank')
    },
    {
        messageId: 'confluence-end-user-activated-jpd_v2',
        heading: $56fef2b484b7e7ea$var$i18n.heading,
        content: $56fef2b484b7e7ea$var$i18n.jpdContent,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($fqxbx))),
        primaryActionText: $56fef2b484b7e7ea$var$i18n.jpdPrimaryButtonText,
        primaryOnClickAction: (environment, orgId, cloudId)=>{
            window.open(`https://${environment === 'PRODUCTION' ? 'admin.atlassian.com' : 'admin.stg.atlassian.com'}/o/${orgId}/products/jira-product-discovery/${cloudId}`, '_blank');
        }
    }
];
const $56fef2b484b7e7ea$var$AppSwitcherNudge = ({ nudge: nudge, fallback: fallback, children: children })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { environment: environment, cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const [dismissed, setDismissed] = (0, $gwFzn.useState)(false);
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    const { messageId: messageId } = nudge; // we have turned off the duplicate check for our messageIds in EP so that the nudge border will be shown repeatedly until
    // the user sees the spotlight. We then use the feature-delivery API to mark the user as having seen it, and stop showing
    // it again (even though the user will remain enrolled in the audience for it)
    const [persistedShowFeature, stopFeature] = (0, $9oxdN.useFeatureDiscovery)(`${messageId}.seen`); // persistedShowFeature becomes false once stopFeature() is called, however, we're using that to just mark the spotlight as seen
    // and we don't want to dismiss the spotlight straight away, so we keep to show it
    const [showFeature, setShowFeature] = (0, $gwFzn.useState)(persistedShowFeature);
    (0, $gwFzn.useEffect)(()=>{
        if (persistedShowFeature) setShowFeature(true);
    }, [
        persistedShowFeature
    ]);
    const hideMessage = (messageId)=>{
        setDismissed(true);
        coordinationClient.stop(messageId);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'endUserActivateSpotlight',
                source: $56fef2b484b7e7ea$export$83c8d7110915321e,
                attributes: {
                    messageId: messageId
                }
            }
        }).fire();
    };
    const handleFireDismissButtonClickEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'endUserActivateSpotlightDismissButton',
                source: $56fef2b484b7e7ea$export$83c8d7110915321e,
                attributes: {
                    messageId: messageId
                }
            }
        }).fire();
    };
    const handleFireTourButtonClickEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'endUserActivateSpotlightTourButton',
                source: $56fef2b484b7e7ea$export$83c8d7110915321e,
                attributes: {
                    messageId: messageId
                }
            }
        }).fire();
    };
    const nudgeSpotlightRef = (0, $gwFzn.useRef)({}); // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    return showFeature && !isSSR ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $axAnW.default), {
        client: coordinationClient,
        messageId: messageId,
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
        attributes: {
            messageId: messageId
        },
        name: "endUserActivateSpotlightNudgeScreen",
        id: "endUserActivateSpotlightNudgeScreenEvent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gR84W.NudgeSpotlight), {
        hidden: dismissed,
        setHidden: ()=>hideMessage(messageId),
        heading: formatMessage(nudge.heading),
        width: 276,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
            attributes: {
                messageId: messageId
            },
            name: $56fef2b484b7e7ea$export$83c8d7110915321e,
            id: `${$56fef2b484b7e7ea$export$83c8d7110915321e}-event`
        }), formatMessage(nudge.content)),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
            xcss: $56fef2b484b7e7ea$var$imgStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
            alt: "",
            src: nudge.image,
            width: 276
        })),
        actions: [
            {
                text: formatMessage(nudge.primaryActionText),
                onClick: ()=>{
                    handleFireTourButtonClickEvent();
                    nudge.primaryOnClickAction(environment, orgId, cloudId);
                }
            },
            {
                text: formatMessage($56fef2b484b7e7ea$var$i18n.secondaryAction),
                onClick: ()=>{
                    handleFireDismissButtonClickEvent();
                    hideMessage(messageId);
                }
            }
        ],
        position: "bottom-end",
        onOutsideClick: ()=>hideMessage(messageId),
        nudgeTestId: `${nudge.messageId}-nudge`,
        cardTestId: `${nudge.messageId}-card`,
        showSpotlightCardOnFirstRender: false,
        onShow: stopFeature,
        nudge: $56fef2b484b7e7ea$var$StyledNudge,
        ref: nudgeSpotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1lhEF.Pulse), {
        testId: `${messageId}-nudge-pulsing-border`,
        radius: 50,
        pulse: !dismissed,
        onFocus: ()=>{
            !dismissed && nudgeSpotlightRef.current?.toggleCardVisibility?.(true);
        }
    }, children)))) : fallback;
};
const $56fef2b484b7e7ea$export$c9637de5a973a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.GenericErrorBoundary), {
        attribution: (0, $dIouf.Attribution).GROWTH_MULTIPLIERS,
        renderOnError: ()=>children
    }, $56fef2b484b7e7ea$export$5871aa9763d9526b.reduce((acc, nudge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56fef2b484b7e7ea$var$AppSwitcherNudge, {
            nudge: nudge,
            fallback: acc
        }, children), children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $56fef2b484b7e7ea$var$NudgeWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18s81nxw _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _shbiidpf _b9uxidpf _15q3idpf _uoh1idpf _1689idpf _1s2fidpf _egytidpf _yl3tidpf _1cmlidpf _hzefidpf _1q5lidpf _97vyidpf _2ynaidpf _1uv9idpf _5gciidpf _17fyidpf",
            __cmplp.className
        ])
    });
});
const $56fef2b484b7e7ea$var$imgStyles = (0, $ecnYn.xcss)({
    height: '154px',
    width: '276px',
    marginBottom: 'space.negative.050'
});

});
parcelRegister("axAnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e9dab50b8978c7c$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
class $7e9dab50b8978c7c$export$2e2bcd8739ae039 extends (0, $gwFzn.PureComponent) {
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $gwFzn.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldRenderChildren: false
        };
        this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}
$7e9dab50b8978c7c$export$2e2bcd8739ae039.defaultProps = {
    fallback: null
};

});

parcelRegister("lwNi3", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $5efec5cf952678ca$export$ddc368dc94a41e62);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $04e9M = parcelRequire("04e9M");

var $jOtRZ = parcelRequire("jOtRZ");

var $lBR3p = parcelRequire("lBR3p");
const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $gwFzn.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};

});
parcelRegister("lBR3p", function(module, exports) {

$parcel$export(module.exports, "getCoordinationClient", () => $b379edbfb382bc54$export$a3f969ef7d35205d);

var $5loD0 = parcelRequire("5loD0");

var $fw9LG = parcelRequire("fw9LG");
const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};

});
parcelRegister("5loD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b61f610720049a6$export$2e2bcd8739ae039);

var $ll2sR = parcelRequire("ll2sR");

var $4nGsu = parcelRequire("4nGsu");
class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}

});



parcelRegister("9oxdN", function(module, exports) {

$parcel$export(module.exports, "useFeatureDiscovery", () => $112f5732a615f62f$export$6de1a7573792d1a9);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $7W8i8 = parcelRequire("7W8i8");

var $bQm3c = parcelRequire("bQm3c");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $iyPd9 = parcelRequire("iyPd9");
const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $d2LG0.default)`query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey featureKey}}`;
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $d2LG0.default)`mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey pluginKey:$pluginKey){pluginKey featureKey}}`;
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (cache, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    const cachedFeatureData = cache.readQuery({
        query: (0, $iyPd9.FeatureDiscoveryQuery)
    });
    if (newMarkedFeature && cachedFeatureData?.featureDiscovery) cache.writeQuery({
        query: (0, $iyPd9.FeatureDiscoveryQuery),
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        }
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $e9zUf.confluenceSessionStorageInstance).getItem(`${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $diswb.useQuery)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $diswb.useMutation)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $gwFzn.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};

});
parcelRegister("iyPd9", function(module, exports) {

$parcel$export(module.exports, "FeatureDiscoveryQuery", () => $b4e2a77d9a5ab99b$export$b3c271f2152800f6);

var $d2LG0 = parcelRequire("d2LG0");
const $b4e2a77d9a5ab99b$export$b3c271f2152800f6 = (0, $d2LG0.default)`query FeatureDiscoveryQuery{featureDiscovery{pluginKey featureKey}}`;

});


parcelRegister("fqxbx", function(module, exports) {
module.exports = new URL("jpd-try-end-learn.5d9c30dc.svg", import.meta.url).toString();

});

parcelRegister("hUCYs", function(module, exports) {
module.exports = new URL("jsm-try-end-learn.c322b649.svg", import.meta.url).toString();

});


parcelRegister("28CXB", function(module, exports) {

let $18ea8cd9b1e32792$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $18ea8cd9b1e32792$var$load("jCNLy"),
    $18ea8cd9b1e32792$var$load("d1uvZ"),
    $18ea8cd9b1e32792$var$load("c6MKV"),
    $18ea8cd9b1e32792$var$load("cyxir"),
    $18ea8cd9b1e32792$var$load("dkU9O"),
    $18ea8cd9b1e32792$var$load("ciAVN"),
    $18ea8cd9b1e32792$var$load("5GXmr")
]).then(()=>parcelRequire('eWL6H'));

});

parcelRegister("3e94X", function(module, exports) {

let $2599b8c697f3fbe4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2599b8c697f3fbe4$var$load("4fCJZ"),
    $2599b8c697f3fbe4$var$load("dTsOE"),
    $2599b8c697f3fbe4$var$load("7GU1S")
]).then(()=>parcelRequire('9lSmU'));

});



parcelRegister("4wH3g", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");
var $34bb8bbd6b8f84d6$require$createLoadable = $jmjWc.createLoadable;

var $398ES = parcelRequire("398ES");
var $34bb8bbd6b8f84d6$require$LoadingPriority = $398ES.LoadingPriority;
function $34bb8bbd6b8f84d6$var$WrappedReactLoadable(opts) {
    const { overrideReactLoadablePriority: overrideReactLoadablePriority } = opts;
    const ReactLoadable = $34bb8bbd6b8f84d6$require$createLoadable(overrideReactLoadablePriority !== undefined ? overrideReactLoadablePriority : $34bb8bbd6b8f84d6$require$LoadingPriority.AFTER_PAINT);
    return ReactLoadable({
        ...opts,
        isReactLoadable: true
    });
}
module.exports = $34bb8bbd6b8f84d6$var$WrappedReactLoadable;

});

parcelRegister("bP2lm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc9ca86dc3d7916919414cea3f7ddc7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89b6467b10c1314e$var$_react = $89b6467b10c1314e$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $89b6467b10c1314e$var$_linkExternal = $89b6467b10c1314e$var$_interopRequireDefault((parcelRequire("8tdj3")));

var $89b6467b10c1314e$var$_shortcut = $89b6467b10c1314e$var$_interopRequireDefault((parcelRequire("8bFzt")));
function $89b6467b10c1314e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkExternalIcon.
 * This component is LinkExternalIcon, with `UNSAFE_fallbackIcon` set to "ShortcutIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89b6467b10c1314e$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $89b6467b10c1314e$var$_react.default.createElement($89b6467b10c1314e$var$_linkExternal.default, Object.assign({
        LEGACY_fallbackIcon: $89b6467b10c1314e$var$_shortcut.default
    }, props));
$89b6467b10c1314e$var$LinkExternalIcon.Name = 'LinkExternalIconMigration';
var $89b6467b10c1314e$var$_default = module.exports.default = $89b6467b10c1314e$var$LinkExternalIcon;

});
parcelRegister("8tdj3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3602017c9c0db571ac57dae4d1f426bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62ab5a81461bade1$var$_react = $62ab5a81461bade1$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $62ab5a81461bade1$var$_baseNew = $62ab5a81461bade1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $62ab5a81461bade1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62ab5a81461bade1$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $62ab5a81461bade1$var$_react.default.createElement($62ab5a81461bade1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$62ab5a81461bade1$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $62ab5a81461bade1$var$_default = module.exports.default = $62ab5a81461bade1$var$LinkExternalIcon;

});

parcelRegister("8bFzt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f5f98ff58973ddb$var$_react = $5f5f98ff58973ddb$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $5f5f98ff58973ddb$var$_linkExternal = $5f5f98ff58973ddb$var$_interopRequireDefault((parcelRequire("8tdj3")));
function $5f5f98ff58973ddb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5f5f98ff58973ddb$var$ShortcutIcon = (props)=>/*#__PURE__*/ $5f5f98ff58973ddb$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props, {
        newIcon: $5f5f98ff58973ddb$var$_linkExternal.default
    }));
$5f5f98ff58973ddb$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $5f5f98ff58973ddb$var$_default = module.exports.default = $5f5f98ff58973ddb$var$ShortcutIcon;

});


parcelRegister("dH6p2", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $ad7aee5d47af256f$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dTk3A = parcelRequire("dTk3A");
var $6fnsQ = parcelRequire("6fnsQ");

var $dh538 = parcelRequire("dh538");
const $ad7aee5d47af256f$var$baseShadow = '0 0 0 3px';
const $ad7aee5d47af256f$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $6fnsQ).P75})`;
const $ad7aee5d47af256f$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $ad7aee5d47af256f$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $ad7aee5d47af256f$var$pulseAnimation = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animationName: 'pulseKeyframes',
    animationDuration: '3000ms',
    animationTimingFunction: $ad7aee5d47af256f$var$easing,
    animationIterationCount: 'infinite'
});
const $ad7aee5d47af256f$var$pseudoStyle = (0, $3jLHL.css)({
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
});
const $ad7aee5d47af256f$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>(0, $3jLHL.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $ad7aee5d47af256f$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$ad7aee5d47af256f$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $ad7aee5d47af256f$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$ad7aee5d47af256f$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $ad7aee5d47af256f$var$pulseAnimation
            ]
        }
    });
const $ad7aee5d47af256f$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $dTk3A.borderRadius)(), pulseColor: pulseColor = $ad7aee5d47af256f$var$basePulseColor, pulseShadowColor: pulseShadowColor = $ad7aee5d47af256f$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $3jLHL.jsx)(CastTargetContainer, {
        css: [
            $ad7aee5d47af256f$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $dh538.fg)('jira_onboarding_experiences_a11y_fixes') && $ad7aee5d47af256f$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $ad7aee5d47af256f$var$inHeritWidthStyles = (0, $3jLHL.css)({
    width: 'inherit'
});

});


//# sourceMappingURL=AppSwitcherComponentWrapper.bd8ba237.js.map
